import React from 'react';
import NotFoundView from '../Common/Components/NotFoundView.jsx';
import { home } from '../Common/Routes/LegacyBreadcrumbs';
import RatesImportPageView from './RateCard/Import/Components/RatesImportPageView.jsx';
import RatesSearchPageView from './RateCard/Search/Components/RatesSearchPageView.jsx';
import RateCardPageView from './RateCard/View/Components/RateCardPageView';
import RatesAuditPageView from './RateCard/Audit/Components/RatesAuditPageView.jsx';
import { Route, Routes } from 'react-router-dom-v5-compat';
import { WrappingRoute } from '../Common/Components/Routes/WrappingRoute';

const ratesBreadcrumbs = [home];

export default (
    <Routes>
        <Route element={<WrappingRoute title='Import rate cards' breadcrumbs={ratesBreadcrumbs} />}>
            <Route path="RateCard/Import" element={ <RatesImportPageView /> } />
        </Route>
        <Route element={<WrappingRoute title='View rate card history' breadcrumbs={ratesBreadcrumbs} />}>
            <Route path="RateCard/Audit" element={ <RatesAuditPageView />} />
        </Route>
        <Route element={<WrappingRoute title='View a rate card' breadcrumbs={ratesBreadcrumbs} />}>
            <Route path="RateCard/:rateCardId" element={ <RateCardPageView /> }/>
        </Route>
        <Route element={<WrappingRoute title='Find rate cards' breadcrumbs={ratesBreadcrumbs} />}>
            <Route path="RateCard" element={ <RatesSearchPageView /> } />
        </Route>
        <Route element={ <WrappingRoute title="Not found" breadcrumbs={ratesBreadcrumbs} /> }>
            <Route element={ <NotFoundView />} />
        </Route>
    </Routes>
);
